module.exports = __webpack_public_path__ + "img/ichra.b14a951e.jpg";